import { useMutation, useQuery } from '@tanstack/react-query'
import { initKYC, initAccountKYC, initAccountParticipantKYC, requestKYCStatusUpdate, getAccountKYC } from '@/kyc/kycApi'
import { API_ROUTES } from '@/common/constants'
import { defaultOptions, QueryOptions } from '@/common/utils/queryOptions'
import { KycProviders } from './types'
import { AccountType, KYCStatus } from '@/common/types'

export const useInitKYC = () => {
    return useMutation({
        mutationFn: (data: { provider: KycProviders; accountType?: AccountType }) => initKYC(data),
        onError: (err) => {
            console.log(err)
        },
    })
}

export const useInitAccountKYC = () => {
    return useMutation({
        mutationFn: (data: { accountId: string; provider: KycProviders; accountType?: AccountType }) =>
            initAccountKYC(data),
        onError: (err) => {
            console.log(err)
        },
    })
}

export const useInitAccountParticipantKYC = () => {
    return useMutation({
        mutationFn: (data: {
            accountId: string
            participantId: string
            provider: KycProviders
            accountType?: AccountType
        }) =>
            initAccountParticipantKYC(data.accountId, data.participantId, {
                provider: data.provider,
                accountType: data.accountType,
            }),
        onError: (err) => {
            console.log(err)
        },
    })
}

export const useFetchKYC = (accountId: string | null, options: QueryOptions<KYCStatus> = defaultOptions) => {
    const { enabled, refetchInterval } = options
    return useQuery({
        queryKey: [API_ROUTES.accountsKyc, accountId],
        queryFn: () => getAccountKYC(accountId!),
        enabled: (enabled ?? true) && Boolean(accountId),
        refetchInterval: refetchInterval as any,
    })
}

export const useRequestKYCStatusUpdate = () => {
    return useMutation({
        mutationFn: () => requestKYCStatusUpdate(),
        onError: (err) => {
            console.log(err)
        },
    })
}
